<div class="carousel-navigation">
  <div class="carousel-navigation-prev">
    <vm-button
      (buttonClick)="onPrev($event)"
      [type]="buttonType.BUTTON"
      [styles]="prevButtonStyle"
      [level]="prevButtonLevel"
      >{{ prevCopy }}</vm-button
    >
  </div>
  <div class="carousel-navigation-next">
    <vm-button (buttonClick)="onNext($event)" [type]="buttonType.BUTTON" [level]="nextButtonLevel">{{
      nextCopy
    }}</vm-button>
  </div>
</div>
